import { useState } from 'react';

/**
 * Whether this screen's charts are open, remembered per browser (CR-33).
 *
 * A manager opens the appointments screen for the picture; a receptionist opens the patients screen
 * to find somebody, and a page of charts above the search box is in their way every time. So the
 * charts open by default and can be folded away, and the choice sticks for that browser.
 *
 * Only a convenience: storage can be missing, full or refused (a private window), and every access
 * is guarded so the screen works the same without it.
 */
export function useChartsShown(screen: string): [boolean, (shown: boolean) => void] {
  const key = `laseera.charts.${screen}`;
  const [shown, setShown] = useState(() => {
    try {
      return window.localStorage.getItem(key) !== 'hidden';
    } catch {
      return true;
    }
  });

  const change = (next: boolean) => {
    setShown(next);
    try {
      if (next) {
        window.localStorage.removeItem(key);
      } else {
        window.localStorage.setItem(key, 'hidden');
      }
    } catch {
      // Remembered for this visit only.
    }
  };

  return [shown, change];
}
